import { Button } from 'components/button/Button'
import { ButtonProps } from 'components/button/types'
import {
  ThemedTextImageSection,
  ThemedTextImageSectionProps,
} from 'components/content/themedTextImageSection/ThemedTextImageSection'
import { Icon, IconName } from 'components/icon'
import { ContentfulImage } from 'components/Image'
import { Spacer } from 'components/spacer/Spacer'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { Namespaces } from 'utils/i18n/types'

interface Props {
  section: Extract<
    keyof Namespaces['digital_protection']['digital_protection'],
    'section_cyberscout' | 'section_dashlane' | 'section_digital_vault'
  >
  extraProps?: ThemedTextImageSectionProps

  ctaIcon: IconName
  ctaHref: string
}

export const DigitalProtectionLPSection = ({ ctaHref, ctaIcon, section, extraProps }: Props) => {
  const { t } = useTranslation('digital_protection')

  const images = useContentfulImages()

  return (
    <>
      <ThemedTextImageSection
        title={t(`digital_protection.${section}.title`)}
        image={<ContentfulImage {...images[`digital_protection_${section}`]} />}
        {...extraProps}
      >
        <Text>{t(`digital_protection.${section}.description`)}</Text>
        <Button {...defaultButtonProps} href={ctaHref} leftIcon={<Icon name={ctaIcon} />}>
          {t(`digital_protection.${section}.cta`)}
        </Button>
      </ThemedTextImageSection>

      <Spacer size={[3, 6]} />
    </>
  )
}

const defaultButtonProps: ButtonProps = {
  type: 'button',
  variant: 'text',
  size: 'large',
  style: { alignSelf: 'start' },
  tone: 'dark',
}
